import { PrivacyLevel } from '../PrivacyLevel';

export default class TeamFinanceSettings {
    public allExpensesPrivacyLevel: PrivacyLevel = PrivacyLevel.Unknown;
    public memberResultsPrivacyLevel: PrivacyLevel = PrivacyLevel.Unknown;
    public defaultGroupPrivacyLevel: PrivacyLevel = PrivacyLevel.Unknown;
}
